import React from 'react';
import { FormControl, Grid, Typography, Card, Radio, RadioGroup, FormControlLabel, Alert } from '@mui/material';

function SelectProvisioningType({ provisioningType, setProvisioningType, apiAuthGroups }) {
    // Determina se l'utente è amministratore
    const isAdmin = Array.isArray(apiAuthGroups) && apiAuthGroups.includes('ADMIN');

    return (
        <Card sx={{ padding: 3 }}>
            <FormControl component="fieldset" fullWidth>
                <Typography variant="h6">Opzione di provisioning</Typography>
                <Alert severity="info" sx={{ my: 2 }}>
                    <Typography variant="body2">
                        <strong>Floating:</strong> gli utenti ricevono una VM dal pool a ogni accesso, la VM può essere diversa tra una sessione e l'altra.
                        Restano disponibili applicazioni e impostazioni, mentre i file salvati localmente sulla VM (es. Desktop/Documenti/Download)
                        non vengono mantenuti. Per conservare i file, utilizzare Google Drive.
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        <strong>Dedicated:</strong> ogni utente viene assegnato a una VM specifica che rimane riservata tra le sessioni.
                    </Typography>
                </Alert>
                <RadioGroup
                    aria-label="provisioningType"
                    name="provisioningType"
                    value={provisioningType}
                    onChange={(e) => setProvisioningType(e.target.value)}
                    row
                >
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <FormControlLabel
                                value="FLOATING"
                                control={<Radio disabled={!isAdmin} />}
                                label="Floating"
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                value="DEDICATED"
                                control={<Radio disabled={!isAdmin} />}
                                label="Dedicated"
                            />
                        </Grid>
                    </Grid>
                </RadioGroup>
                {!isAdmin && (
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        Solo gli amministratori possono modificare questa opzione.
                    </Typography>
                )}
            </FormControl>
        </Card>
    );
}

export default SelectProvisioningType;
